export default __webpack_public_path__ + "be8e31ef9c85c742abea77056f09ba84.svg";